import { Suspense } from 'react';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { lazy } from 'utils/generic/lazy';
import { isMobile } from 'utils/is-mobile';
import './wrapperStyles.less';

const { HooryAICompactComponent } = lazy(
  () => import(/* webpackChunkName: "hoory-ai-compact" */ './Component')
);

export const HooryAICompact = () => {
  const isHooryEnabled =
    SpringConfigs.HOORY_ENABLED &&
    SpringConfigs.HOORY_ENABLED_SPORTSBOOK_BETSLIP;

  return isHooryEnabled ? (
    <Suspense
      fallback={
        <div
          className={
            !isMobile()
              ? 'hooryAiCompactDesktopWrapper'
              : 'hooryAiCompactMobileWrapper'
          }
        />
      }
    >
      <div
        className={
          !isMobile()
            ? 'hooryAiCompactDesktopWrapper'
            : 'hooryAiCompactMobileWrapper'
        }
      >
        <HooryAICompactComponent />
      </div>
    </Suspense>
  ) : null;
};
